import React, { useEffect, useState } from 'react';
import ColumnListWithCheckbox from 'components/searchAndFilter/components/columnListWithCheckbox';
import { WithTabBackButtonStateProps, withTabBackButton } from 'components/tab';
import { TableViews } from '../constants';
import { RMCustomButtonProps } from 'components/customComponents/CommonComponents/RMCustomButton/RMCustomButton';
import PanelFooter from 'components/searchAndFilter/components/panelFooter';
import { Props as ILabelRowWithActionsProps } from 'components/searchAndFilter/components/labelRowWithActions';
import InfoBox from 'components/alerts/infoBox';

interface Props extends WithTabBackButtonStateProps {
  setPanelState: React.Dispatch<React.SetStateAction<TableViews>>;
  setColumnStatus: React.Dispatch<
    React.SetStateAction<{ [columnName: string]: boolean }>
  >;
  columns: { [columnName: string]: boolean };
}

const MAX_ALLOWED_COLUMNS = 3;

const EditTableContainer = (props: Props) => {
  const { setHandleOnTabBackPress, setPanelState, setColumnStatus, columns } = props;

  const [columnsListState, setColumnsListState] = useState<{
    [columnName: string]: boolean;
  }>({});

  const [selectionCount, setSelectionCount] = useState(0);

  useEffect(() => {
    setHandleOnTabBackPress(() => () => {
      setPanelState(TableViews.VIEW_TABLE);
    });
  }, [setHandleOnTabBackPress]);

  useEffect(() => {
    setColumnsListState({ ...columns });
    let _count = 0;
    Object.values(columns).forEach((val) => {
      if (val === true) {
        _count += 1;
      }
      setSelectionCount(_count);
    });
  }, [columns]);

  const onCheckboxChange = (columnName) => {
    setColumnsListState((prev) => {
      const updated = { ...prev };

      //applying check count constraint
      if (selectionCount === MAX_ALLOWED_COLUMNS && updated[columnName] === false) {
        return updated;
      }

      updated[columnName] = !updated[columnName];

      setSelectionCount(updated[columnName] ? selectionCount + 1 : selectionCount - 1);

      return updated;
    });
  };

  const onApply = () => {
    setColumnStatus({ ...columnsListState });
    setPanelState(TableViews.VIEW_TABLE);
  };

  const isColumnStatusSameAsPrevious = () => {
    return Object.keys(columnsListState).every(
      (colName) => columnsListState[colName] === columns[colName],
    );
  };

  const buttons: RMCustomButtonProps[] = [
    {
      title: 'Apply',
      onClick: onApply,
      mainContainerClass: `bg-[#4CAF50] w-[70px] h-[26px] rounded-[4px] pt-[4px] pr-[10px] pb-[4px] pl-[10px] ${
        isColumnStatusSameAsPrevious() ? 'bg-[#cacaca] text-[#9e9e9e]' : ''
      }`,
      contentContainerClass: 'text-[#ffffff]',
      isDisabled: isColumnStatusSameAsPrevious(),
    },
  ];

  const getColumns = (): ILabelRowWithActionsProps[] => {
    return Object.keys(columnsListState).map((parameterName, index) => {
      let isDisabled = false;
      if (selectionCount === MAX_ALLOWED_COLUMNS && !columnsListState[parameterName]) {
        isDisabled = true;
      }
      return {
        isVisible: false,
        isChecked: columnsListState[parameterName],
        onCheckboxChange: () => {
          onCheckboxChange(parameterName);
        },
        columnId: index,
        columnTitle: parameterName,
        disabled: isDisabled,
      };
    });
  };

  return (
    <div id="searchandfilter-table-edittablecontainer" className={'flex flex-col'}>
      <InfoBox
        title={'You only able to select 3 table header to show in the side panel'}
      />
      <div id="searchandfilter-table-edittablecontainer-columnlist" className="h-[68vh]">
        <ColumnListWithCheckbox columns={getColumns()} />
      </div>
      {<PanelFooter buttons={buttons} />}
    </div>
  );
};

export default withTabBackButton(EditTableContainer);
